import { useTranslation } from "react-i18next";
import "../../i18n";
import { StatTile } from "../../design/components";
import { OUTBOUND_STAGES } from "../../domain/stages";
import type { DashboardSummary, StageCounts } from "../../api/types";

const IN_FLIGHT_STAGES = OUTBOUND_STAGES.slice(0, OUTBOUND_STAGES.indexOf("archived"));

export function inFlightTotal(counts: StageCounts): number {
  return IN_FLIGHT_STAGES.reduce((sum, stage) => sum + (counts[stage] ?? 0), 0);
}

export function StatRow({ summary }: { summary: DashboardSummary }) {
  const { t } = useTranslation();
  const { entities, documents24h, exceptions, stageCounts, staleTrackingCount } = summary;
  const total = entities.live + entities.onboarding + entities.notStarted;
  const attention = exceptions.terminal + exceptions.held + staleTrackingCount;

  return (
    <div className="grid g4">
      <StatTile
        label={t("dashboard.statRow.companiesLive", "Companies live")}
        value={entities.live}
        meta={t("dashboard.statRow.ofTotal", "of {{total}}", { total })}
      />
      <StatTile
        label={t("dashboard.statRow.documents24h", "Documents (24 h)")}
        value={documents24h.outbound + documents24h.inbound}
        meta={t("dashboard.statRow.outInMeta", "{{outCount}} out · {{inCount}} in", {
          outCount: documents24h.outbound,
          inCount: documents24h.inbound,
        })}
      />
      <StatTile
        label={t("dashboard.statRow.inFlight", "In flight")}
        value={inFlightTotal(stageCounts)}
        meta={t("dashboard.statRow.beforeArchive", "Before archive")}
      />
      <StatTile
        label={t("dashboard.statRow.needsAttention", "Needs attention")}
        value={attention}
        meta={
          `${exceptions.terminal} terminal · ${exceptions.held} held` +
          (staleTrackingCount > 0 ? ` · ${staleTrackingCount} stale` : "")
        }
        {...(attention > 0 ? { tone: "var(--fail)" } : {})}
      />
    </div>
  );
}
